import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import { LoadingOverlaySmall } from "./LoadingOverlay";

export default function TableMui({
  th,
  td,
  styleTableTh,
  styleTableContainer,
  styleTableThead,
  second,
  headerRounded,
  rowRounded,
  customFields,
  loading,
}) {
  const found = (key) => customFields?.find((obj) => obj.name === key);

  return (
    <>
      <TableContainer
        style={{
          maxHeight: "500px",
          overflowY: "auto",
          overflowX: "auto",
          ...styleTableContainer,
        }}
      >
        <Table
          aria-label="simple table"
          stickyHeader
          style={{
            borderCollapse: "separate",
            borderSpacing: "0px 0px",
            minWidth: "900px",
          }}
        >
          {/* Table Header */}
          <Header
            headerRounded
            values={{
              styleTableThead,
              th,
              loading,
              styleTableTh,
            }}
          />

          {/* Table Body */}
          {!loading && (
            <TableBody>
              {td?.length > 0 ? (
                td.map((row, index) => (
                  <MuiTableRow
                    key={index}
                    rowRounded
                    second={second}
                    values={{ row, th, index, found, customFields }}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={Object.keys(th).length}
                    align="center"
                    style={{
                      backgroundColor: "#fcf5d8",
                      padding: "16px",
                    }}
                  >
                    <div className="w-full h-[300px] my-12">
                      <img
                        className="w-full h-full "
                        src="/norecords.svg"
                        alt=""
                      />
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>

      {/* Loading Overlay */}
      {loading && <LoadingOverlaySmall open={loading} />}
    </>
  );
}

const MuiTableRow = ({ values, rowRounded, second }) => {
  const { row, th, index, found, customFields } = values;
  const rowStyle = {
    overflow: "auto",
    height: "10px",
  };

  return (
    <TableRow key={index} sx={{ ...rowStyle }}>
      {Object.keys(th).map((key, ind) => (
        <TableCell
          key={ind}
          className="p-4"
          style={{
            backgroundColor: "#fcf5d8",
          }}
          align="center"
        >
          {customFields && found(key)
            ? found(key)?.data(row[key], row)
            : getNestedValue(row, key)}
          {key === "sr" && index + 1}
        </TableCell>
      ))}
    </TableRow>
  );
};

const Header = ({ values, headerRounded }) => {
  const { styleTableThead, th, loading, styleTableTh } = values;
  const headerStyle = {
    backgroundColor: "#fde047",
    borderBottom: "1px solid black",
  };

  return (
    <TableHead sx={{ ...headerStyle, ...styleTableThead }}>
      <TableRow>
        {Object.entries(th).map(([key, value], index) => (
          <TableCell
            key={index}
            align="center"
            sx={{
              ...styleTableTh,
              position: "sticky",
              top: 0,
              backgroundColor: "#fde047",
              zIndex: 1,
            }}
          >
            {value}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const getNestedValue = (obj, key) => {
  const keys = key.split(".");
  return keys.reduce(function (acc, currentKey) {
    return acc && acc[currentKey] !== undefined ? acc[currentKey] : "";
  }, obj);
};
